<template>
	<div id="app">
		<router-view v-wechat-title="$route.meta.title" />
	</div>
</template>

<script>
export default {
	name: 'App',
	data(){
		return {}
	},
	methods: {}
}
</script>

<style lang="less">
@import './assets/style/mixin';
</style>
